var CustomForm = {
  onChange: function(elem) {
    CustomForm.showOrHide($(elem).parents(".sa-form-field"));
    CustomForm.filterField($(elem).parents(".sa-form-field"));
    CustomForm.cellPhoneDisclosure($(elem).parents(".sa-form-field"));

    $(elem).trigger('sa-form:change');
  },

  initOptionFilterState: function() {
    // Set initial option filter state - unfortunately, this must be done
    // client-side.
    $('option.hide-me-immediately').each(function() { $(this).toggleOption(false); });
  },

  cellPhoneDisclosure: function(field){
    if(field.data('flavor') === 'phone'){
      var phoneType = field.find('[data-flavor="phone.type"] :selected');
      var hiddenPhoneType = field.find('[data-flavor="phone.type.hidden"]')
      var optIn =  field.find('[data-flavor="phone.opt_in"]');
      if (phoneType.text() === 'Cell' || hiddenPhoneType.val() === 'Cell') {
        optIn.removeClass('hidden');
      } else {
        optIn.addClass('hidden');
      }
    }
  },

  // Shows or hides the given field and its dependencies.
  showOrHide: function (field) {
    CustomForm.forEachDependent(field, function(){
      // Check each dependent field
      let allTriggered = true;
      let dependentField = $(this);

      CustomForm.forEachDependency(dependentField, function (dd_name) {
        // For each dependent, check if each of their dependency's is triggered
        if (!allTriggered) {
          // skip if we've already found an untriggered
          return;
        }

        let dd_field = CustomForm.fieldFromFieldName(dd_name);
        let dd_values = CustomForm.valueOf(dd_field);

        if (dd_field.length < 1) {
          // Try to find values in the off page attribute
          dd_field = dd_name;
          dd_values = CustomForm.valueOfOffPage(dd_field, dependentField);
        }

        if (!CustomForm.isTriggered(dependentField, dd_values, dd_field)) {
          allTriggered = false;
        }
      });

      if (allTriggered) {
        $(this).removeClass('hidden');
        CustomForm.showOrHide(this);
      } else {
        CustomForm.hideAll(this);
      }

      if (CustomForm.isLikertField(this)) {
        /*
         If no explicit dependency for a likert definition is declared,
         it is implicitly dependent on the visibility of all its questions.
         In a perfect world, this would be handled with multiple field
         dependencies, but we don't support that yet and need to handle
         this common use case.
         */
        CustomForm.showOrHideLikertDefinition(this);
      }
    });
  },

  // Invokes callback for all dependents of field (dep. is accessed via +this+ within callback).
  forEachDependent: function(field, callback) {
    var field_name = $(field).attr("field_name");
    $('.' + field_name + '-dependent, .' + field_name + '-dependent-transitive').each(callback);
  },

  // Invokes callback for all dependencies (as field name) of field (accessed via this within callback)
  forEachDependency: function(field, callback) {
    var dependency_list = $(field).attr('class').split(/\s+/);
    $.each(dependency_list, function(idx, dependency) {
      const class_match = dependency.match(/(.*)-dependent/);
      if (class_match !== null) {
        callback(class_match[1]);
      }
    });
  },

  fieldFromFieldName: function(field_name) {
    return $(".sa-form-field[field_name='" + field_name + "']");
  },

  // Returns true if field is triggered for the given values of the given dependency.
  isTriggered: function(field, values, dependency, is_opt_filt_dep) {
    // assumed that trigger values are trimmed and lowercase
    // dependency - field name or jquery obj representing the dependency to check
    // is_opt_filt_dep - (default: false) indicates whether to use trigger values for option filter dependencies
    var dep_field_name = (dependency instanceof jQuery) ? dependency.attr("field_name") : dependency;
    if (typeof is_opt_filt_dep === 'undefined') {
      is_opt_filt_dep = false;
    }

    var trigger_values;
    if (is_opt_filt_dep) {
      trigger_values = JSON.parse($(field).attr('filter'))[dep_field_name + '-opt-filt-dep-trigger-values'];
    } else {
      trigger_values = JSON.parse($(field).attr(dep_field_name + '-depends-trigger-values'));
    }

    var trigger_values_attr = dep_field_name + (is_opt_filt_dep ? "-opt-filt-dep-trigger-values" : "-depends-trigger-values");

    for (var i = 0; i < values.length; i++) {
      if ($.inArray(CustomForm.sanitizeValue(values[i]), trigger_values) != -1) {
        return true;
      }
    }
    return false;
  },

  // Hides the specified field and all its dependencies.
  hideAll: function(field) {
    $(field).addClass('hidden');
    var field_name = $(field).attr("field_name");
    if (field_name !== "") {
      $('.X-dependent, .X-dependent-transitive'.replace(/X/g, field_name)).addClass('hidden');
    }
  },

  // Gets the normalized values of a custom field whether a boolean, single select, or boolean list.
  valueOf: function(field) {
    var selector = "input.dependency-value[type='hidden'], input[type='radio']:checked, input[type='checkbox']:checked, select option:selected";

    var answers = $(field).find(selector)
      .map(function(i, elem) {
        return CustomForm.sanitizeValue($(elem).val());
      });

    return answers;
  },

  // Gets the normalized values of a custom field that is off page
  valueOfOffPage: function(field_name, dependentField) {
    var values = JSON.parse($(dependentField).attr('off-page-answers'))[field_name];

    // Always return an array
    if (!$.isArray(values)) {
      values = [values];
    }

    return values.map(function(val, idx) {
      return CustomForm.sanitizeValue(val);
    });
  },

  // Returns boolean indicating whether this field is a likert question.
  isLikertField: function(elem) {
    return $(elem).closest('.sa-form-field[data-flavor="likert"]').length > 0;
  },

  // Shows or hides the definition field of a likert question based on if all the subquestions are hidden.
  showOrHideLikertDefinition: function(elem) {
    var likert_element = $(elem).closest('.sa-form-field[data-flavor="likert"]');
    var definition_field_row = likert_element.find('.sa-form-field[data-flavor="likert_definition"]').first();
    var all_children_hidden = true;

    // If this definition is dependent (on anything), do _not_ do this.
    if (definition_field_row.is("[class*='dependent']")) {
      return;
    }

    likert_element.find('.sa-form-field').each(function(){
      if (this !== definition_field_row.get(0) && $(this).is(':visible')) {
        all_children_hidden = false;
        // Break out of loop.
        return false;
      }
    });

    // Hide or show.
    if (all_children_hidden) {
      definition_field_row.addClass('hidden');
    }
    else {
      definition_field_row.removeClass('hidden');
    }

    // Reevaluate colors - these are set in /sa/form.less, too.
    $('.sa-form-field[data-flavor="likert"]:visible:nth-child(odd)').css('background', '#F9F9F9');
    $('.sa-form-field[data-flavor="likert"]:visible:nth-child(even)').css('background', '');
  },

  // Set likert scale initial visibility state.
  initLikertScaleVisibility: function() {
    $('table.likert').each(function() {
      CustomForm.showOrHideLikertDefinition(this);
    });
  },

  // Filter options list for fields that use this field as a filter.
  filterField: function(field) {
    var field_value = CustomForm.valueOf(field)[0]; // Grab the first, this should never get called for non single-selects
    var filter_field_name = $(field).attr("field_name");

    CustomForm.applyNestedFilter = function (field, filtered_options, field_value, targetElementValue) {
      if(field_value === '' && targetElementValue === '') {
        CustomForm.unfilterOptions($(field));
      } else {
        // Get the nested filter based on the selected values
        const nestedFilter = filtered_options[field_value] ? filtered_options[field_value][targetElementValue] : null;
        CustomForm.filterOptions($(field), nestedFilter);
      }
    }

    // Loop through each field filtered by this one
    CustomForm.forEachFiltered(field, function () {
      var filtered_options = JSON.parse($(this).attr('filter'))[filter_field_name + '-options'];
      const checkDepth = CustomForm.getObjectDepth(filtered_options)
      /*
      Checking to see if we have a nested filtered object.
      We can only have a nested filtered object if a form has an admin created filter for apply_grade and we have auto close date.
      Normal Example: {
        'child_apply_year': {
          'year2011.id': [...],
          'year2012.id': [...]
        }
      }
      Nested Example: {
        'child_custom_boarding_or_day_ss': {
          'day': {
            'year2011.id': [...],
            'year2012.id': [...]
          },
          'boarding': {
            'year2011.id': [...],
            'year2012.id': [...]
          }
        }
      }
      */
      if (checkDepth > 2) {
        // Target the div that handles apply_year to get its selected value.
        const targetElement = $('div[field_name="child_apply_year"]');
        const targetElementValue = CustomForm.valueOf(targetElement)[0]

        CustomForm.applyNestedFilter(this, filtered_options, field_value, targetElementValue);

        // Add a secondary listener to child_apply_year which would be the only use case as of now.
        targetElement.off('change.customForm').on('change.customForm', () => {
          const updatedTargetElementValue = CustomForm.valueOf(targetElement)[0];
          CustomForm.applyNestedFilter(this, filtered_options, field_value, updatedTargetElementValue);
        });
      }
      else {
        if (field_value === '') {
          CustomForm.unfilterOptions($(this));
        }
        else {
          CustomForm.filterOptions($(this), filtered_options[field_value]);
        }
      }
    });

    // If this field is a dependency for any filter field - check that field's visibility
    CustomForm.forEachFilterDependent(filter_field_name, function() {
      var allTriggered = true;
      var filter_dep_field = $(this);

      CustomForm.forEachFilterDependency(filter_dep_field, function(fd_name) {
        // Loop through all option filter dependencies for this field, make sure they're all triggered
        if (!allTriggered) {
          return;
        }

        var fd_field = CustomForm.fieldFromFieldName(fd_name);
        var fd_values;
        if (fd_field.length < 1) {
          fd_field = fd_name;
          fd_values = CustomForm.valueOfOffPage(fd_field, filter_dep_field);
        } else {
          fd_values = CustomForm.valueOf(fd_field);
        }

        if (!CustomForm.isTriggered(filter_dep_field, fd_values, fd_field, true)) {
          allTriggered = false;
        }
      });

      if (allTriggered) {
        // Enable filter on filter_dep_field
        var filter_name = CustomForm.optionFilterNameFromField(filter_dep_field);
        var filtered_options = JSON.parse(filter_dep_field.attr('filter'))[filter_name + '-options'];

        // Grab value of this filter, regardless of page location
        var filter_field = CustomForm.fieldFromFieldName(filter_name);
        var fd_values;
        var filter_value;
        if (filter_field.length < 1) {
          filter_field = fd_name;
          filter_value = CustomForm.valueOfOffPage(filter_field, filter_dep_field)[0];
        } else {
          filter_value = CustomForm.valueOf(filter_field)[0];
        }

        CustomForm.filterOptions(filter_dep_field, filtered_options[filter_value]);
      } else {
        // Disable filter on filter_dep_field
        CustomForm.unfilterOptions(filter_dep_field);
      }
    });


  },

  // Return the option filter field of a field
  optionFilterNameFromField: function(field) {
    var class_list = $(field).attr('class').split(/\s+/);
    var filter_name = null;
    $.each(class_list, function(idx, cls) {
      const class_match = cls.match(/(.*)-filtered/);
      if (class_match !== null) {
        filter_name = class_match[1];
        return false;
      }
    });

    return filter_name;
  },

  // Filter a field to just the allowed options
  filterOptions: function(field, option_values) {
    // Single selects and BooleanlistFields are handled differently
    if (field.data('flavor') == 'booleanlist') {
      return CustomForm.filterBooleanlistOptions(field, option_values);
    } else {
      return CustomForm.filterSingleSelectOptions(field, option_values);
    }
  },

  // Filter a Booleanlist field to just the allowed options
  filterBooleanlistOptions: function(field, option_values, unfilter) {
    // field - booleanlist field to filter
    // option_values - array of allowed option values
    // unfilter - boolean indicating whether to unfilter completely (optional)
    if (typeof unfilter === 'undefined') {
      unfilter = false;
    }

    // These label elements wrap the actual checkbox inputs
    var boxes = field.find('.sa-form-booleanlist-option');
    var allowed_boxes = [];
    var disallowed_boxes = [];
    var change_val = false;

    // Loop through each checkbox
    boxes.each(function() {
      // Add to allowed/disallowed lists
      var input = $(this).find('input');
      if (unfilter || $.inArray(CustomForm.sanitizeValue(input.prop('value')), option_values) >= 0) {
        allowed_boxes.push($(this));
      } else {
        disallowed_boxes.push($(this));
        if (input.is(':checked')) {
          // We need to re-eval dependencies later
          change_val = true;
          input.prop('checked', false);
        }
      }
    });

    // Hide before remove to avoid glitchiness
    var bg = field.find('.sa-form-booleanlist-group');
    bg.find('.sa-form-booleanlist-row').addClass('hidden');
    boxes.detach();
    bg.find('.sa-form-booleanlist-row').remove();

    // Sort allowed values
    allowed_boxes.sort(function(a, b) {
      var sort_a = parseInt($(a).find('input').attr('sort'), 10);
      var sort_b = parseInt($(b).find('input').attr('sort'), 10);
      return sort_a - sort_b;
    });

    // Add allowed
    var num_of_cols = parseInt(field.find('.sa-form-booleanlist-group').attr('columns'), 10);
    var allowed_rows = CustomForm.arrangeByRow(allowed_boxes, num_of_cols);
    bg.append(allowed_rows);

    // Add disallowed - hidden
    var disallowed_rows = CustomForm.arrangeByRow(disallowed_boxes, num_of_cols);
    bg.append(disallowed_rows.addClass('hidden'));

    // Re-evaluate depends if necessary
    if (change_val) {
      CustomForm.showOrHide(field);
    }
  },

  arrangeByRow: function(elements, num_of_cols) {
    // hidden - indicates whether to hide the rows
    var num_of_rows = Math.ceil(elements.length/num_of_cols);
    var new_rows = $();

    for (var i = 0; i < num_of_rows; i++) {
      var row = $('<div></div>').addClass('sa-form-booleanlist-row');
      new_rows = new_rows.add(row);

      for (var j = 0; j < num_of_cols; j++) {
        var index = i * num_of_cols + j;

        if (index < elements.length) {
          row.append(elements[index]);
        }
      }
    }
    return new_rows;
  },

  // Filter a select field to just the allowed options
  filterSingleSelectOptions: function(field, option_values) {
    var change_val = false;
    // Change current value if it's disallowed
    field.find('option').each(function() {
      if ($(this).prop('value') === '') {
        // Blanks are always allowed
        return true;
      }

      if ($.inArray(CustomForm.sanitizeValue($(this).prop('value')), option_values) >= 0) {
        // Allowed option
        $(this).toggleOption(true);
      } else {
        // Disallowed option
        $(this).toggleOption(false);

        if ($(this).is(':selected')) {
          // Unselect and mark that a value has changed
          $(this).prop('selected', false);
          change_val = true;
        }
      }
    });

    if (change_val || field.find('select option:selected').val() === null) {
      // If the current value is disallowed, switch to the first allowed one
      field.find('select').val(field.find('select > option').first().prop('value'));

      // Dependencies need to be reevaluated for this field since its value changed
      CustomForm.showOrHide(field);
    }
  },

  // Remove options filter
  unfilterOptions: function(field) {
    if (field.find('.booleanlist-group').length) {
      // This is a booleanlist field
      CustomForm.filterBooleanlistOptions(field, [], true);
    } else {
      // Must be a single select
      field.find('option').each(function() { $(this).toggleOption(true);});
    }
  },

  // Invokes callback for all fields that are filtered by this one.
  forEachFiltered: function(field, callback) {
    var field_name = $(field).attr("field_name");
    $('.' + field_name + '-filtered').each(callback);
  },

  // Invoke callback for each dependency of an option filter
  forEachFilterDependent: function(field_name, callback) {
    $('.' + field_name + '-opt-filt-dep').each(callback);
  },

  // Invoke callback for each option filter dependency of this field
  forEachFilterDependency: function(field, callback) {
    var dependency_list = $(field).attr('class').split(/\s+/);
    $.each(dependency_list, function(idx, dependency) {
      const class_match = dependency.match(/(.*)-opt-filt-dep/);
      if (class_match !== null) {
        callback(class_match[1]);
      }
    });
  },

  sanitizeValue: function(val) {
    if (typeof val === 'undefined' || val === null) {
      return val;
    } else {
      val = val.toString();
      return $.trim(val).toLowerCase();
    }
  },

  // Finding the depth of an object.
  getObjectDepth: function (obj) {
    if (obj === null || typeof obj !== 'object') return 0;

    return Object.keys(obj).reduce((maxDepth, key) => {
      const depth = this.getObjectDepth(obj[key]);
      return Math.max(maxDepth, depth);
    }, 0) + 1;
  }
};

export default CustomForm;

global.CustomForm = global.CustomForm || CustomForm;
